export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API,
  authDomain: 'reddit-clone-marco1.firebaseapp.com',
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: 'reddit-clone-marco1.appspot.com',
  messagingSenderId: '343200661202',
  appId: process.env.REACT_APP_APP_ID,
};
